import { createTypes } from 'reduxsauce'
import { IComponentState, IPaginator } from '../root.types'
import { PotentialPatient } from '../../application/models/potential.patient/potentialPatient'

export const ActiveSearchTypes = createTypes(`

    LOAD_ACTIVESEARCH_SUCCESS
    LOAD_ACTIVESEARCH_FAILURE 
    LOAD_ACTIVESEARCH_REQUEST

    FIND_ACTIVESEARCH_SUCCESS
    FIND_ACTIVESEARCH_FAILURE 
    FIND_ACTIVESEARCH_REQUEST

    REMOVE_ACTIVESEARCH_REQUEST
    REMOVE_ACTIVESEARCH_SUCCESS
    REMOVE_ACTIVESEARCH_FAILURE

    RESET_PAGINATOR
    HANDLE_DIALOG
    STORE_ACTIVESEARCH

    HANDLE_PROMOTE_REQUEST
    HANDLE_PROMOTE_SUCCESS
    HANDLE_PROMOTE_FAILURE

    PROMOTE_ACTIVESEARCH_REQUEST
    PROMOTE_ACTIVESEARCH_SUCCESS
    PROMOTE_ACTIVESEARCH_FAILURE

    REJECT_ACTIVESEARCH_REQUEST
    REJECT_ACTIVESEARCH_SUCCESS
    REJECT_ACTIVESEARCH_FAILURE
`,
    {
        prefix: '@activesearch/'
    }
)

/**
 * State type
 */
export interface IActiveSearchState {
    readonly create: ICreateState
    readonly list: IListState
    readonly dialog: boolean
}

export interface IPaginatorModified extends Omit<IPaginator, 'search'> {
    search: IFilter
}

export interface IListState extends IComponentState {
    readonly activeSearches: PotentialPatient[]
    readonly paginator: IPaginatorModified
}
export interface ICreateState extends IComponentState {
    readonly activeSearch: PotentialPatient
}
export interface IActionLoad {
    readonly paginator?: IPaginatorModified
}
export interface IActionCreate {
    readonly activeSearch: PotentialPatient
}
export interface IActionFind {
    readonly activeSearchId: string
}
export interface IActionActiveSearch {
    readonly date: string
    readonly paginator?: IPaginatorModified
}

export interface IFilter {
    readonly state: string[] | string | undefined
    readonly city: string | undefined
}